<template>
  <div v-if="theModel">
    <div class="row justify-between q-mx-sm q-py-none no-wrap">
      <div class="col">
        <linear-chart-panel v-if="[0, 3, 6, 9, 12, 15, 18, 21].includes(theModel.Descriptor)" v-model="theModel" />
        <pie-chart-panel v-else-if="[1, 4, 7, 10, 13, 16, 19, 22].includes(theModel.Descriptor)" v-model="theModel" />
        <bar-chart-panel v-else-if="[2, 5, 8, 11, 14, 17, 20, 23].includes(theModel.Descriptor)" v-model="theModel" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import { ChartSettingsBase } from '@/models/interfaces/entity-settings/charts/charts';
import LinearChartPanel from '../charts/linear/LinearChartPanel.vue';
import PieChartPanel from '../charts/pie/PieChartPanel.vue';
import BarChartPanel from '../charts/bar/BarChartPanel.vue';

@Component({
  name: 'BaseChartPanel',
  components: { LinearChartPanel, PieChartPanel, BarChartPanel }
})
export default class BaseChartPanel extends Vue {
  // v-model
  @Prop({ default: {} as ChartSettingsBase })
  modelValue: any | undefined
  @Emit("update:modelValue") emitModelValue(arg: ChartSettingsBase | undefined ) { return arg; }

  get theModel(): ChartSettingsBase | undefined {
    return this.modelValue
  }

  set theModel(val: ChartSettingsBase | undefined) {
    this.emitModelValue(val)
  }
}
</script>

<style lang="scss">
</style>